// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sign-up completion page — Figma 1541-25505/25506: vertically centered in the
   viewport, clear of the fixed auth header (~96px) so it isn't overlapped. */
.signup-success-page {
  min-height: calc(100vh - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 40px 24px;
}

/* Figma has no card chrome — drop the legacy .register-success box-shadow/radius. */
.signup-success-page .register-success {
  box-shadow: none;
  border-radius: 0;
}

/* Sign-up completion page — Figma 1541-25505: centered, no illustration,
   title + gray subtitle, primary blue pill, secondary as a plain text link. */
.signup-success-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 16px 0 8px;
  text-align: center;
}

.signup-success-subtitle {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  margin: 0 0 24px;
  max-width: 360px;
}

.signup-success-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 340px;
}

.signup-success-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  padding: 0 20px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.signup-success-btn--primary {
  background: #3054f1;
  color: #fff;
  border: 1px solid #3054f1;
}

.signup-success-btn--primary:hover {
  background: #2543c9;
  border-color: #2543c9;
  color: #fff;
}

/* Secondary action is a plain text link (Figma), not a button. */
.signup-success-link {
  color: #3054f1;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.signup-success-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/signUpSuccess/SignUpSuccess.css"],"names":[],"mappings":"AAAA;6EAC6E;AAC7E;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Sign-up completion page — Figma 1541-25505/25506: vertically centered in the\n   viewport, clear of the fixed auth header (~96px) so it isn't overlapped. */\n.signup-success-page {\n  min-height: calc(100vh - 96px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 40px 24px;\n}\n\n/* Figma has no card chrome — drop the legacy .register-success box-shadow/radius. */\n.signup-success-page .register-success {\n  box-shadow: none;\n  border-radius: 0;\n}\n\n/* Sign-up completion page — Figma 1541-25505: centered, no illustration,\n   title + gray subtitle, primary blue pill, secondary as a plain text link. */\n.signup-success-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 16px 0 8px;\n  text-align: center;\n}\n\n.signup-success-subtitle {\n  color: #6b7280;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: center;\n  margin: 0 0 24px;\n  max-width: 360px;\n}\n\n.signup-success-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 340px;\n}\n\n.signup-success-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 48px;\n  padding: 0 20px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.signup-success-btn--primary {\n  background: #3054f1;\n  color: #fff;\n  border: 1px solid #3054f1;\n}\n\n.signup-success-btn--primary:hover {\n  background: #2543c9;\n  border-color: #2543c9;\n  color: #fff;\n}\n\n/* Secondary action is a plain text link (Figma), not a button. */\n.signup-success-link {\n  color: #3054f1;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.signup-success-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
